export default {
    studentNum: {
        allCount: 172,
        manCount: 117,
        womanCount: 55,
        thisYear: 10,
        girlRate: 32,
        manRate: 68,
    },
    teacherNum: 128,

};
